import { Link } from '@inertiajs/react';
import { ExternalLink } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { SponsorRow } from '@/types';
import { DeleteSponsorDialog } from './DeleteSponsorDialog';
import { EditSponsorDialog } from './EditSponsorDialog';

interface SponsorsTableProps {
  eventSlug: string;
  sponsors: SponsorRow[];
}

export function SponsorsTable({ eventSlug, sponsors }: SponsorsTableProps) {
  if (sponsors.length === 0) {
    return (
      <div className="p-8 text-center text-muted-foreground">
        <p>No sponsors found.</p>
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[150px]">Slug</TableHead>
            <TableHead>Name</TableHead>
            <TableHead className="w-[100px]">Credits</TableHead>
            <TableHead className="w-[80px]">URL</TableHead>
            <TableHead className="w-[140px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sponsors.map((sponsor) => (
            <TableRow key={sponsor.id}>
              <TableCell>
                <code className="rounded bg-muted px-1.5 py-0.5 text-xs">
                  {sponsor.slug}
                </code>
              </TableCell>
              <TableCell>
                <Link
                  href={`/admin/${eventSlug}/sponsors/${sponsor.slug}`}
                  className="font-medium text-sm hover:underline"
                >
                  {sponsor.name}
                </Link>
              </TableCell>
              <TableCell>
                <Badge variant="outline">{sponsor.creditCount}</Badge>
              </TableCell>
              <TableCell>
                {sponsor.url ? (
                  <a
                    href={sponsor.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted-foreground hover:text-foreground"
                  >
                    <ExternalLink className="h-4 w-4" />
                  </a>
                ) : (
                  <span className="text-muted-foreground">-</span>
                )}
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-1">
                  <EditSponsorDialog eventSlug={eventSlug} sponsor={sponsor} />
                  <DeleteSponsorDialog
                    eventSlug={eventSlug}
                    sponsorId={sponsor.id}
                    sponsorName={sponsor.name}
                  />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
